/**
 * React Reduxアプリケーションのエントリーポイントです。
 * Reduxストアを作成し、ReactアプリケーションをReduxに接続します。
 *
 * @returns {void}
 */
import { Provider } from 'react-redux';

import { createRoot } from 'react-dom/client';

import { Routes } from './routes/routes';
import { store } from './store/index';

import './style/index.scss';

const container = document.getElementById('root');
/**
 * ルート要素が見つからない場合にエラーをスローします。
 *
 * @throws {Error} ルート要素が見つからなかった場合にスローされるエラー
 */
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  /**
   * Reduxストアを提供するためにReact ReduxのProviderコンポーネントを使用します。
   * アプリケーションの全体にReduxストアが利用可能になります。
   *
   * @example
   * <Provider store={store}>
   *   <Routes />
   * </Provider>
   */
  <Provider store={store}>
    <Routes />
  </Provider>
);
